// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"314":"17264845","422":"6e7c02e1","595":"f99b33b6","679":"2c0639ce","869":"56da60e6"}[chunkId] + ".chunk.js";
};